const Login = () => import(/* webpackChunkName: "login" */ '@/components/login/Index.vue')
const ForgotPass = () => import(/* webpackChunkName: "login" */ '@/components/login/ForgotPass.vue')

export const ROUTE_NOT_AUTHENTICATED = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/esqueci-minha-senha',
    name: 'ForgotPass',
    component: ForgotPass
  }
]
